module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteDocumentType":"Delete Document Type","deleteDocumentTypeText":"Are you sure you want to delete this document type?"},"al":{"deleteDocumentType":"Fshi llojin e Dokumentit","deleteDocumentTypeText":"A jeni i sigurt se dëshironi të fshini këtë lloj dokumenti?"}}')
  delete Component.options._Ctor
}
